import React, {forwardRef} from 'react';
import cn from 'classnames';

import {IDangerousHtmlProps} from './IDangerousHtml';

const DangerousHTML = forwardRef(({html, classNames, as = 'div', style}: IDangerousHtmlProps, ref:  React.Ref<any>) => {
	const TagName = as;

	return <TagName ref={ref} dangerouslySetInnerHTML={{__html: html}} className={cn(classNames)} style={style} />;
});

export default DangerousHTML;
